import { FC, ReactElement, useState, useEffect } from 'react'
import styled from 'styled-components'

type ToggleValue = {
  label: string
  value: string
}

const ToggleButton = ({
  choices,
  onChange,
}: {
  choices: ToggleValue[]
  onChange: (value: 'children' | 'adults') => void
}) => {
  const [selected, setSelected] = useState(choices[0].value)

  useEffect(() => {
    onChange(selected as 'children' | 'adults')
  }, [selected, onChange])

  return (
    <ToggleButtonContainer
      onClick={() => {
        setSelected(
          choices[(choices.findIndex((c) => c.value === selected) + 1) % 2]
            .value
        )
      }}
    >
      {choices.map((choice, i) => (
        <Element selected={selected === choice.value} key={`toggleOption-${i}`}>
          {choice.label}
        </Element>
      ))}
    </ToggleButtonContainer>
  )
}

const ToggleButtonContainer = styled.div`
  display: inline-block;
  font-family: var(--font-sans-serif);
  font-size: 1em;
  background: ${({theme}) => theme.colorMode === 'dark' ? theme.purpleMain : theme.purpleDark};
  border-radius: 100px;
  color: #ffffffef;
  cursor: pointer;
  position: relative;
  user-select: none;
  line-height: 1;
  font-weight: 700;
  font-size: 0.8em;
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.025),
    0px 0px 12px rgba(0, 0, 0, 0.025);
}
`

const Element = styled.div<{ selected: boolean }>`
  display: inline-block;
  padding: 0.75em 1em;
  border-radius: 100px;
  color: ${({ selected, theme }) => (selected ? theme.purpleMain : '#fefefe')};
  background: ${({ selected, theme }) => (selected ? '#ffffff' : 'transparent')};
  border: 2px solid ${({theme}) => theme.colorMode === 'dark' ? theme.purpleMain : theme.purpleDark};

  &:first-child {
    margin-left: -1px;
  }

  &:last-child {
    padding-left: 0.85em;
  }
`

export default ToggleButton
